interface EHRInfo {
  integrationType: string;
  ehrName: string;
}

let ehrInfoState: EHRInfo | null = null;

export const getEHRInfoState: () => EHRInfo | null = () => ehrInfoState;
export const resetEHRInfoState = () => {
  ehrInfoState = null;
};
export const updateEHRInfoState = (newVal: EHRInfo) => {
  ehrInfoState = newVal;
};

export type { EHRInfo };
